export enum Routes {
  Home = '/',
  Creator = '/content-creator-group-travel',
  MbaExclusive = '/mba-exclusive',
  WellnessRetreat = '/wellness-retreat',
  PlanATrip = '/plan-a-trip',
}
